(() => {


  let accordionButton     = document.getElementsByClassName('js-Item-Accordion_Button');
  //let accordionButtonIcon = document.getElementsByClassName('js-Item-Accordion_Button_Icon');a
  let accordionBox        = document.getElementsByClassName('js-Item-Accordion_Box');

  for(let i = 0; i < accordionButton.length; i++){
    accordionButton[i].addEventListener('click', () => {
      let accordionStatus = accordionBox[i].dataset.status;
      if(accordionStatus === 'visible'){
        accordionBox[i].dataset.status        = 'hidden';
        accordionButton[i].dataset.status = 'hidden';
      } else {
        accordionBox[i].dataset.status        = 'visible';
        accordionButton[i].dataset.status = 'visible';
      }
    }, false);
  }

  $("a[href^=#]").on("click", function(){
    var linkSpeed = 800;
    var linkHref = $(this).attr("href");

    var linkTarget = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
    var linkPosition = linkTarget.offset().top;
    $("html, body").animate({scrollTop: linkPosition}, linkSpeed, "swing");

    return false;
  });

  let topButton = document.getElementById('js-Item-Top_Button');

  window.addEventListener('scroll', () => {
    if(window.pageYOffset > 100) {
      topButton.classList.remove('sw-Top-Hidden');
    } else {
      topButton.classList.add('sw-Top-Hidden');
    }
  }, false);

  $(function () {
    $('.hit-01 a').click(function(){
      $('#hit-01').fadeIn();
    });
    $('.miss-01 a').click(function(){
      $('#miss-01').fadeIn();
    });
    $('.hit-02 a').click(function(){
      $('#hit-02').fadeIn();
    });
    $('.miss-02 a').click(function(){
      $('#miss-02').fadeIn();
    });
    $('.hit-03 a').click(function(){
      $('#hit-03').fadeIn();
    });
    $('.miss-03 a').click(function(){
      $('#miss-03').fadeIn();
    });
    $('.close').click(function(){
      $('.idx-Contents_Modal').fadeOut();
    });
  });

  // $(function () {
  //   $(window).on("load",function(){
  //     $(".idx-Contents_Modal .wrapper").mCustomScrollbar({
  //       theme:"minimal-dark"
  //     });
  //   });
  // });

})();



// WEBPACK FOOTER //
// ./src/assets/js/script.js